// client/src/api/DestinationsApi.ts
import { axiosInstance as api } from "../helpers/request";
import { IStreamingPlatformKey } from "../types/interfaces";
import { IStreamingPlatform } from "../types/models";

const base = (streamId: string) => `/streams/${streamId}/destinations`;

class DestinationsApi {
  list(streamId: string) {
    return api.get<IStreamingPlatform[]>(base(streamId));
  }
  create(streamId: string, body: Omit<IStreamingPlatformKey, "id">) {
    return api.post<IStreamingPlatform>(base(streamId), body);
  }
  update(streamId: string, id: string, body: Omit<IStreamingPlatformKey, "id">) {
    return api.put<IStreamingPlatform>(`${base(streamId)}/${id}`, body);
  }
  remove(streamId: string, id: string) {
    return api.delete<IStreamingPlatform>(`${base(streamId)}/${id}`);
  }
}

const destinationsApiInstance = new DestinationsApi();
export default destinationsApiInstance;
